interface Props {
    isNavLinkSeparator?: boolean;
}

export const NavGroupSeparator = ({isNavLinkSeparator}: Props) => {
    const marginY = isNavLinkSeparator ? "my-1" : "my-2";
    return <div className={`border-separator h-1 border-t ${marginY}`} />;
};
